import { scoreBuckets } from 'lib/scorekeeper';
import { concatAll} from 'lib/util'

export function parseSuggestionResults(page) {
    const suggestionsReturned = [];
    // If suggestions were returned normally but there is no suggestion for the keyword,
    // log it and don't loop inside page Object
    if (typeof page.buckets === 'undefined') {
        return suggestionsReturned;
    }

    let foundVideo = false;
    let foundEvent = false;

    const suggestions = concatAll(page.buckets.map((bucket) => {
        return bucket.contents;
    })).reduce((suggestions, suggestion) => {
        if (suggestion.type === 'event') {
            if (!foundEvent) {
                suggestions.push('Events:');
                foundEvent = true;
            }
        } else if (suggestion.type === 'video'){
            if (!foundVideo){
                suggestions.push('Videos:');
                foundVideo = true;
            }
        }
        suggestions.push(suggestion.suggestion);
        return suggestions;
    }, []).filter((oneSuggestion) =>
        suggestionsReturned.indexOf(oneSuggestion) === -1
    );

    return suggestions;
}



// WEBPACK FOOTER //
// ./app/lib/format/parseSearchAPIResults.js